/*
 * @Author: zhangqf
 * @Date: 2018-11-26 15:31:27 
 * @Last Modified by: Scherger
 * @Last Modified time: 2019-05-30 15:04:54
 * 
 * 作为 utils 公共文件出口
 */


// request 请求文件
import ccRequest from './cc-webapp/request.js'

//這裡是全局的基礎工具方法
import ccBaseUtils from './cc-webapp/baseUtils.js'

//app页面跳转方法 
import ccApp from './cc-webapp/navigator.js'

//app登录方法 
import ccLogin from './cc-webapp/login.js'

//app 电子书下载方法 
import ccEpubDownload from './cc-webapp/downloadEpub.js'




export default {
  // install,
  ccRequest,
  ccBaseUtils,
  ccApp,
  ccLogin,
  ccEpubDownload,
}



// WEBPACK FOOTER //
// ./src/utils/index.js